import { reactive } from 'vue'

/** 全局自建确认弹框（替代 ElMessageBox）的共享状态，单一实例。 */
export interface ConfirmDialogState {
  visible: boolean
  title: string
  message: string
  confirmText: string
  cancelText: string
  resolve: ((value: boolean) => void) | null
}

export const confirmDialogState = reactive<ConfirmDialogState>({
  visible: false,
  title: '',
  message: '',
  confirmText: '确定',
  cancelText: '取消',
  resolve: null,
})

export function isConfirmDialogOpen() {
  return confirmDialogState.visible
}

/** 关闭弹框并以结果 resolve（保证只 resolve 一次）。 */
export function settleConfirmDialog(value: boolean) {
  if (!confirmDialogState.visible) return
  confirmDialogState.visible = false
  const r = confirmDialogState.resolve
  confirmDialogState.resolve = null
  r?.(value)
}

/** 以一条新请求打开全局确认框；若已有确认框在显示则不打断，直接视为取消。 */
export function openConfirmDialog(
  message: string,
  title: string,
  options?: { confirmButtonText?: string; cancelButtonText?: string },
): Promise<boolean> {
  if (confirmDialogState.visible) return Promise.resolve(false)
  confirmDialogState.message = message
  confirmDialogState.title = title
  confirmDialogState.confirmText = options?.confirmButtonText ?? '确定'
  confirmDialogState.cancelText = options?.cancelButtonText ?? '取消'
  confirmDialogState.visible = true
  return new Promise<boolean>((resolve) => {
    confirmDialogState.resolve = resolve
  })
}
